import { Injectable } from "@angular/core";
import { LocalStorageService } from "@indusoft/angular-base-services";

import { BaseValidationStore } from "../../../common/services/base-validation-store";
import { AuthQueryParams } from "../glossary/auth-query-params-glossary";
import { AuthSteps } from "../models/auth-steps";

@Injectable()
export class AuthStore extends BaseValidationStore {
    private _login: string;
    private _password: string;
    private _rememberMe: boolean = false;
    private _authStep: AuthSteps = AuthSteps.LOGIN_PASSWORD_STEP;
    private _returnUrl: string;

    constructor(private storageService: LocalStorageService) {
        super();
    }

    public setReturnUrl(returnUrl: string): void {
        this._returnUrl = returnUrl;
        this.storageService.setValue(AuthQueryParams.RETURN_URL_PARAM, returnUrl);
    }

    public clearReturnUrl(): void {
        this._returnUrl = undefined;
        this.storageService.deleteValue(AuthQueryParams.RETURN_URL_PARAM);
    }

    public get login(): string {
        return this._login;
    }

    public set login(login: string) {
        this._login = login;
    }

    public get password(): string {
        return this._password;
    }

    public set password(password: string) {
        this._password = password;
    }

    public get rememberMe(): boolean {
        return this._rememberMe;
    }

    public set rememberMe(rememberMe: boolean) {
        this._rememberMe = rememberMe;
    }

    public get authStep(): AuthSteps {
        return this._authStep;
    }

    public set authStep(authStep: AuthSteps) {
        this._authStep = authStep;
    }

    // Тут хранятся данные, которые были в урле перед редиректом на форму логина.
    // Изза различных редиректов при доменном логине, данные сохраняются в хранилище.
    // После ухода с формы логина, данные очищаются в следующем загруженом компоненте.
    public get returnUrl(): string {
        return this._returnUrl ?? this.storageService.getValue(AuthQueryParams.RETURN_URL_PARAM);
    }

    public get isValid(): boolean {
        return this.isLoginValid === true
            && this.isPasswordValid === true;
    }

    public get isLoginValid(): boolean {
        return this.isTrue(() => !!this._login);
    }

    public get isPasswordValid(): boolean {
        return this.isTrue(() => !!this._password);
    }
}
